import { Colors } from "@/enums/Colors";
import { FormControl, FormControlProps, formLabelClasses, outlinedInputClasses, textFieldClasses } from "@mui/material";
import { styled } from "@mui/system";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${formLabelClasses.root}`]: {
    fontSize: "0.75rem",
    fontWeight: "500",
    paddingLeft: "0.5rem",
    paddingBottom: "0.25rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem",
      paddingLeft: "0.75rem",
      paddingBottom: "0.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
    },
  },
  [`& .${textFieldClasses.root}`]: {
    height: "2.75rem",
    [theme.breakpoints.down("sm")]: {
      height: "3rem",
    },
    [theme.breakpoints.down("xs")]: {
      height: "3.25rem",
    },
    [`& .${outlinedInputClasses.root}`]: {
      height: "2.75rem",
      [theme.breakpoints.down("sm")]: {
        height: "3rem",
      },
      [theme.breakpoints.down("xs")]: {
        height: "3.25rem",
      },
      [`&.Mui-focused fieldset`]: {
        border: `1px solid ${Colors.LAZO_PURPLE}`,
        [theme.breakpoints.down("sm")]: {
          border: `2px solid ${Colors.LAZO_PURPLE}`,
        },
      },
      [`& .${outlinedInputClasses.notchedOutline}`]: {
        border: `1px solid ${Colors.STROKE_DARK_GRAY}`,
        borderRadius: "0.5rem",
        [theme.breakpoints.down("sm")]: {
          border: `1.5px solid ${Colors.STROKE_DARK_GRAY}`,
          borderRadius: "0.75rem",
        },
      },
      [`& .${outlinedInputClasses.input}`]: {
        fontSize: "0.875rem",
        fontWeight: "400",
        padding: "0.75rem",
        [theme.breakpoints.down("sm")]: {
          fontSize: "1rem",
          padding: "1rem",
          lineHeight: "1.2",
        },
        [theme.breakpoints.down("xs")]: {
          fontSize: "1.125rem",
          padding: "1.125rem",
        },
      },
      [`&.${outlinedInputClasses.error}`]: {
        color: Colors.RED,
        [`& .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: Colors.RED,
          [theme.breakpoints.down("sm")]: {
            borderWidth: "2px",
          },
        },
      },
    },
  },
}));

function CommonFormControl(props: FormControlProps) {
  return <StyledFormControl {...props}>{props.children}</StyledFormControl>;
}

export default CommonFormControl;
